<template>
  <div class="analysis-data">
    <div className="name">
      {{ data.measuredValue }}
      {{ data.analysisType.name }}
    </div>
  </div>
</template>

<script>

export default {
    name: 'AnalysisData',

    props: {
        data: {
            type: Object,
            default: () => ({
                measureValue: null,
                analysisType: { name: null },
            }),
        },
    },
};
</script>

<style lang="scss" scoped>
.analysis-data {
    width: 100%;
    margin-right: 8px;

    color: black;
    font-size: 12px;
}
</style>
